// This file is part of Indico.UN.
// Copyright (C) 2019 - 2023 United Nations. All rights reserved.

import {handleAxiosError, indicoAxios} from 'indico/utils/axios';

document.addEventListener('DOMContentLoaded', async () => {
  $('.vc-toolbar').dropdown({
    positioning: {
      level1: {my: 'right top', at: 'right bottom', offset: '0px 0px'},
    },
  });

  document.querySelectorAll('.vc-toolbar .action-make-host').forEach(elem => {
    elem.addEventListener('click', async () => {
      const killProgress = IndicoUI.Dialogs.Util.progress();
      try {
        await indicoAxios.post(elem.dataset.href);
        window.location.reload();
      } catch (error) {
        handleAxiosError(error);
        killProgress();
      }
    })
  })
});
